<template>

    <v-text-field 
    class="mb-1"
    hide-details="auto"
    :label=this.column.title 
    @keyup.enter = "handleInput"
    v-model = "cvalue" 
    variant="outlined"

    :append-inner-icon = AppendInnerIcon
    @click:append-inner = "handleClick"

    >


    <template v-slot:append-inner>
        <v-btn size="29" variant="outline" class="d-flex d-sm-none d-none d-sm-flex d-md-none"  color="regular" @click = "handleClick">
            <svg-icon type="mdi" :path="mdiMagnify"/>
        </v-btn>
    </template>
<!--все это извращенство с кнопкой надо, чтобы обойти вопрос использoвания тяжых webfonts-->


    </v-text-field> 
 
        <v-btn
            class="my-1 mr-1"
            variant="flat"
            color="regular"
            v-for="(f, index) in v" :key="index"
            @click="deleteItem(index)"
        >
        <div class="text-truncate" style="max-width: 250px;">{{f}} </div><svg-icon type="mdi" :path="mdiCloseCircle"/>
        </v-btn>

</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiMagnify, mdiCloseCircle } from '@mdi/js';
export default {
    name: 'StringFilter',
    components: {
        SvgIcon,
    },
    props:['column', 'modelValue'],
    emits: ['update:modelValue', 'filterupdate'],
    data(){ 
        return {
            mdiMagnify:mdiMagnify,
            mdiCloseCircle:mdiCloseCircle,
            v: [],
            cvalue: "",
            rules: [
//        value => (value && value.length >= 3) || 'Min 3 characters',
      ],
        }
    },
    methods:{

        handleClick(){
//            console.log(this.cvalue);
            this.v.push(this.cvalue); 
            this.cvalue = ""; 
            //console.log(this.cvalue);        
            this.$emit('update:modelValue', this.v.join(';'));
            //console.log(this.v); 
            this.$emit('filterupdate');

        },

        handleInput(e) {     
            this.v.push(e.target.value); 

            this.cvalue = ""; 
//console.log(this.cvalue);        
            this.$emit('update:modelValue', this.v.join(';'));
//console.log(this.v); 
            this.$emit('filterupdate');
//console.log(this.v);
        },

        deleteItem(index) {
            this.v.splice(index, 1);
            this.$emit('update:modelValue', this.v.join(';'));
            this.$emit('filterupdate');
        },

        
    },

}
</script>